import styled from "styled-components";

export const AtualizarEstoqueContainer = styled.div`
  margin-top: 15px;
  background-color:#F4F5F5;

`;
export const AtualizarEstoqueContainerText = styled.div`
  font-family: Akrobat;
  background-color: #9a649e;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const Filter = styled.div`
  width: 1340px;
  height: 80px;
  margin-top: 10px;
  position: relative;
  margin-left: auto;
  font-family: "Akrobat";
  margin-right: auto;
  // background-color: #9a649e;

  h1 {
    text-align: center;
    font-size: 20px;
    font-family: "Akrobat";
    color: #3d567a;
    margin-top: 20px;
  }
`;
export const FilterControl = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  align-items: center;
  font-family: "Akrobat";

  button {
    width: 90px;
    height: 37px;
    border: none;
    border-radius: 3px;
    margin-left: 5px;
    font-size: 18px;
    font-family: "Akrobat";
    color: white;
    background-color: #9a649e;
    cursor: pointer;
  }
`;
export const Content = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const Tables = styled.div`
  .grid {
    flex-direction: column;
  }
  .table {
    margin: 0 auto;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  thead {
    th {
      padding: 10px 20px;
      color: #ff0000;
      font-size: 14px;
      font-weight: 400;
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color:#F4F5F5;
      }
      td {
        padding: 0 20px;
        text-align: center;
        font-size: 14px;
        height: 30px;
        max-width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;
export const ModalContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.404);
  // background-color: transparent;
  position: fixed;
  top: -0px;
  z-index: 99999;
  display: flex;
  align-items: center;
`;
export const ModalContainerContent = styled.div`
  width: 1100px;
  min-height: 315px;
  box-shadow: 2px 2px 15px 2px rgba(228, 228, 228, 0.493);
  background-color: #ffffff;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
  border: none;
`;
export const ModalContainerContentHeader = styled.div`
  width: 100%;
  height: 30px;
  background-color: #9a649e;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 16px;
    color: white;
    letter-spacing: 0.03rem;
    font-family: "Akrobat SemiBold";
  }
  span {
    position: absolute;
    top: 3px;
    left: 90%;
    float: right;
    font-size: 18px;
    font-family: "Akrobat";
    color: white;
    cursor: pointer;
  }
`;
export const ModalContainerDataGrid = styled.div`
  width: 95%;
  min-height: 300px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;
export const ModalContainerDataGridTable = styled.div`
  width: 100%;
  min-height: 195px;
  background-color: white;
  border: 0.3px solid $line_opacity;
  margin-bottom: 20px;
  table {
    width: 100%;
  }
  thead {
    color: white;
    font-size: 16px;
    font-family: "Akrobat";

    // font-size: 16px;
    // font-family: 'Akrobat';
    // color: black;
    // position: relative;
    // margin-left: 5px;
    th {
      background-color: #9a649e;
      border: 5px solid #9a649e;
      border-left: 15px solid #9a649e;
      border-right: 15px solid #9a649e;
      // border: 10px solid transparent;
    }
  }

  tbody {
    background-color: #f5f5f5;
    color: black;
    text-align: center;
    font-size: 16px;
    font-family: "Akrobat";
    // position: relative;
    // margin-left: 5px;
    tr {
      height: 20px;
      td {
        border: 0.5px solid #f5f5f5;
        font-family: "Akrobat";
        border-top: 2px solid white;
        border-left: 5px solid white;
        border-right: 1px solid white;
        // color: black;
        // position: relative;
        // text-align: center;

        div {
          width: 120px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: white;
          input {
            border: none;
            width: 100px;
            height: 35px;
            outline: none;
          }
          label {
            font-family: "Akrobat";
            font-size: 15px;
            background-color: white;
          }
        }

        a {
          color: $cor_base_1;
        }
      }
    }
  }
`;
export const ModalContainerFooter = styled.div`
  width: 100%;
  height: 80px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    width: 197px;
    height: 51px;
    background-color: #9a649e;
    font-size: 20px;
    font-family: "Akrobat";
    color: white;
    border: none;
    border-radius: 5px;
    margin-top: 10px;
    margin-right: 7px;
    cursor: pointer;
    display:flex;
    justify-content:center;
    align-items:center;
  }
`;
